module.exports = __webpack_public_path__ + "img/greencar.5e668544.png";